import { YStack } from '@shinetools/lumen-react'

import type { Contact } from '@features/contacts/types/contact'

import { AutomationRule } from './elements/AutomationRule'
import { CompanyInformation } from './elements/CompanyInformation'

interface SupplierDetailInformationProps {
  contact: Contact
}

export const SupplierDetailInformation = ({ contact }: SupplierDetailInformationProps) => {
  return (
    <YStack gap={24}>
      <CompanyInformation contact={contact} />
      <AutomationRule contact={contact} />
    </YStack>
  )
}
